import React from 'react'
import cx from 'classnames'
import { Icon, palettes, l } from '@manychat/manyui'

import { BorderLoader } from 'apps/aiAssistantNew/components/BorderLoader/BorderLoader'

import cm from './StepLayout.module.css'

interface StepLayoutProps {
  widgetTitle?: React.ReactNode
  header?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode

  visuallyEmptyHeader?: boolean
  showWidgetTitle?: boolean

  scrollerRef?: React.RefObject<HTMLDivElement>

  isLoading?: boolean
  showContentOnLoading?: boolean
  showFooterOnLoading?: boolean
}

export const StepLayout = ({
  widgetTitle,
  header,
  children,
  footer,

  visuallyEmptyHeader,

  scrollerRef,

  isLoading,
  showContentOnLoading = true,
  showFooterOnLoading = true,
  showWidgetTitle = true,
}: StepLayoutProps) => {
  return (
    <div className={cm.wrapper}>
      <BorderLoader isBusy={isLoading} gradientClassName={cm.borderLoader}>
        {widgetTitle && <div className={cx(cm.widgetTitle)}>{widgetTitle}</div>}
        {showWidgetTitle && !widgetTitle && (
          <div className={cx(cm.widgetTitle)}>
            <Icon.Ai size={20} className="flex-shrink-0" />

            <h1 className="m-0 text-subheading text-ellipsis">{l.translate('Improve with AI')}</h1>
          </div>
        )}

        <div className={cx(cm.mainArea, !showWidgetTitle && cm.mainArea__full_height)}>
          <section
            className={cx(
              cm.contentWrapper,
              header && !visuallyEmptyHeader && cm.contentWrapper_withHeader,
              header && visuallyEmptyHeader && cm.contentWrapper_withVisuallyEmptyHeader,
            )}
          >
            {header && <header className={cm.header}>{header}</header>}

            {isLoading && !showContentOnLoading && (
              <div className="d-flex align-center justify-center p-b-md">
                <Icon.Ai color={palettes.typography.border} size={48} />
              </div>
            )}

            <div
              ref={scrollerRef}
              className={cx(cm.content, isLoading && !showContentOnLoading && 'd-none')}
            >
              {children}
            </div>

            {footer && (
              <footer className={cx(cm.footer, isLoading && !showFooterOnLoading && 'd-none')}>
                {footer}
              </footer>
            )}
          </section>
        </div>
      </BorderLoader>
    </div>
  )
}
